import React from "react";
import SlotText from "../../invitation/SlotText";

// The interlude: text slots `interludeHeading` / `interludeBody`.
const ExclusivelyCraftedText = ({ hideTopLines = false }) => {
  return (
    <div className="p-wrap">
      {!hideTopLines && <div className="vert-line _35vh mbm-exclusion"></div>}
      <div className="p-block" style={hideTopLines ? { borderTop: "none" } : undefined}>
        <div
          data-w-id="44fdff4f-73c0-eaad-0d6f-6ca7c9797acb"
          style={{
            transform:
              "translate3d(0, 70px, 0) scale3d(1, 1, 1) rotateX(-72deg) rotateY(23deg) rotateZ(0) skew(0, 13deg)",
            transformStyle: "preserve-3d",
            opacity: 0,
          }}
          className="pad-20"
        >
          <SlotText slot="interludeHeading" as="h3" className="heading-50" />
        </div>
        <SlotText
          slot="interludeBody"
          as="p"
          data-w-id="44fdff4f-73c0-eaad-0d6f-6ca7c9797ace"
          style={{
            transform:
              "translate3d(0, 70px, 0) scale3d(1, 1, 1) rotateX(-72deg) rotateY(23deg) rotateZ(0) skew(0, 13deg)",
            transformStyle: "preserve-3d",
            opacity: 0,
          }}
          className="body-20"
        />
      </div>
      <div className="vert-line mbm-exclusion"></div>
    </div>
  );
};

export default ExclusivelyCraftedText;
